import { CalculationsList } from "../CalculationsList"
import { ActiveCalculationCard } from "../ActiveCalculationCard"
import { useCalculationsProvider } from "../../contexts"
import { CalculationGridBanner } from "../CalculationGridBanner/CalculationGridBanner"
import { useIsMobile } from "~/hooks/useWindowSize"

export const CalculationsGrid = () => {
  const { calculations, activeCalculationIndex, activeCalculation } = useCalculationsProvider()
  const isMobile = useIsMobile()

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-5">
      <CalculationsList calculations={calculations} />
      {activeCalculation ? (
        <div className="col-span-1 lg:col-span-2">
          <ActiveCalculationCard
            /* We can use the key here to bypass React reconciliation, and making sure React re-renders the component with new props
             * Since the underlying component uses a form, this will make sure that the form is created with the proper initial values
             */
            key={activeCalculationIndex}
            calculation={activeCalculation}
          />
          {!isMobile && (
            <CalculationGridBanner
              numberOfCalculations={calculations.length}
              activeCalculationCountry={activeCalculation.country.name}
            />
          )}
        </div>
      ) : null}
    </div>
  )
}
